import threeTierLeftHeader from '../assets/compact/three-tier-left.svg';
import threeTierMiddleHeader from '../assets/compact/three-tier-middle.svg';
import threeTierRightHeader from '../assets/compact/three-tier-right.svg';
import twoTierLeftHeader from '../assets/compact/two-tier-left.svg';
import twoTierRightHeader from '../assets/compact/two-tier-right.svg';
import threeTierLeftCard from '../assets/regular/three-tier-left.svg';
import threeTierMiddleCard from '../assets/regular/three-tier-middle.svg';
import threeTierRightCard from '../assets/regular/three-tier-right.svg';
import twoTierLeftCard from '../assets/regular/two-tier-left.svg';
import twoTierRightCard from '../assets/regular/two-tier-right.svg';

export type SvgTiersMapTypes = 'regular' | 'compact';

export const svgTiersMap: Record<
  SvgTiersMapTypes,
  {
    threeTierLeft: string;
    threeTierMiddle: string;
    threeTierRight: string;
    twoTierLeft: string;
    twoTierRight: string;
  }
> = {
  regular: {
    threeTierLeft: threeTierLeftCard,
    threeTierMiddle: threeTierMiddleCard,
    threeTierRight: threeTierRightCard,
    twoTierLeft: twoTierLeftCard,
    twoTierRight: twoTierRightCard,
  },
  compact: {
    threeTierLeft: threeTierLeftHeader,
    threeTierMiddle: threeTierMiddleHeader,
    threeTierRight: threeTierRightHeader,
    twoTierLeft: twoTierLeftHeader,
    twoTierRight: twoTierRightHeader,
  },
};
